export const DEFAULT_DELAY = 300;

export const IP_ADDRESS_REGEX = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/;
export const URL_PATH_REGEX = /^((\/){1}([a-zA-Z0-9@:%_+~#=])+)*(\?([\d\w]+=[\d\w]+(&[\d\w]+=[\d\w]+)*)+)?$/;
export const HOSTNAME_REGEX = /^(?!-)[a-zA-Z0-9-]*$/;
